import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

const STATS = [
  { value: 250, suffix: "+", label: "Lanes served", id: "lanes" },
  { value: 28, suffix: "", label: "States & UTs covered", id: "states" },
  { value: 96, suffix: "%", label: "On-time consignments", id: "ontime" },
  { value: 800, suffix: "K+", label: "Tonnes moved annually", id: "tonnes" },
];

const CountUp = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: "easeOut",
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref}>
      {display.toLocaleString("en-IN")}
      <span className="text-amber-500">{suffix}</span>
    </span>
  );
};

export const StatsBand = () => (
  <section data-testid="stats-band" className="border-y border-slate-800 bg-[#161B22]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid grid-cols-2 lg:grid-cols-4 gap-px bg-slate-800">
      {STATS.map((s) => (
        <div
          key={s.id}
          data-testid={`stat-${s.id}`}
          className="bg-[#161B22] px-6 py-8 flex flex-col gap-2"
        >
          <span className="font-display text-3xl sm:text-4xl font-black text-slate-100 tracking-tight">
            <CountUp value={s.value} suffix={s.suffix} />
          </span>
          <span className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            {s.label}
          </span>
        </div>
      ))}
    </div>
    <p className="mono max-w-7xl mx-auto px-5 sm:px-8 pb-4 -mt-4 text-[10px] uppercase tracking-[0.15em] text-slate-600">
      * Indicative figures — replace with confirmed operational data before launch
    </p>
  </section>
);
